import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=2eb0dc8e&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=ts"
export * from "./Videos.vue?vue&type=script&lang=ts"
import style0 from "./Videos.vue?vue&type=style&index=0&id=2eb0dc8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb0dc8e",
  null
  
)

export default component.exports
import {QCard,QCardSection,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QCardActions,QBtn})
